import { render, staticRenderFns } from "./approvalNotificationDetails.vue?vue&type=template&id=da128648&scoped=true&"
import script from "./approvalNotificationDetails.vue?vue&type=script&lang=js&"
export * from "./approvalNotificationDetails.vue?vue&type=script&lang=js&"
import style0 from "./approvalNotificationDetails.vue?vue&type=style&index=0&id=da128648&prod&scoped=true&lang=css&"
import style1 from "./approvalNotificationDetails.vue?vue&type=style&index=1&id=da128648&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da128648",
  null
  
)

export default component.exports